<script lang="ts">
	import { load_image_from } from 'src/helpers/interface_helpers';
	import { onDestroy } from 'svelte';
	import type { CloudImageSize } from './types/cloud-recordings';
	import ImageContainer from './DeviceDrawer/RecordingsTab/ImageContainer.svelte';
	import { createThumbnailResolver } from './helpers/encryption/recording-image-decryption';

	export let deviceId = '';
	export let src: string | undefined = '';
	export let encrypted = false;
	/** Size `src` was taken from; drives the encrypted-thumbnail nonce. */
	export let imageSize: CloudImageSize = 'large';
	/** Optional recording id; enables per-recording HKDF key derivation for
	 * recording-bound thumbnails. Omit for device-level latest thumbnails. */
	export let recId: string | undefined;
	/** Optional recording ISO `date`; selects the rotation era active at that date
	 * for recording-bound thumbnails. Omit for device-level latest thumbnails. */
	export let recDate: string | undefined;

	const placeholder = load_image_from('images/device_images/logo_white_S.png');

	let resolvedUrl = '';
	let loading = false;
	const resolver = createThumbnailResolver(
		(url) => (resolvedUrl = url),
		(isLoading) => (loading = isLoading),
	);

	$: resolver.update({ deviceId, url: src, encrypted, size: imageSize, recId, recDate });

	/** Never pass an empty src so the logo placeholder shows during load and on failure. */
	$: displaySrc = resolvedUrl || placeholder;

	/** Show a lock over the placeholder when encrypted and without a key */
	$: lockIcon = encrypted && !resolvedUrl && !loading ? 'fal fa-lock' : null;

	onDestroy(resolver.destroy);
</script>

<ImageContainer
	src={displaySrc}
	{...$$restProps}
	{loading}
	overlayIcon={lockIcon ?? $$restProps.overlayIcon}
	on:click
>
	<slot name="topLeft" slot="topLeft" />
</ImageContainer>
